import { clampPct, formatNumber } from '../../lib/format';

export const ProgressBar = ({ sold, total, soldOut = false }) => {
  const pct = total ? clampPct((sold / total) * 100) : 0;
  return (
    <div data-testid="tickets-progress">
      <div className="h-2 bg-[color:var(--pd-bg)] border border-pd rounded-full overflow-hidden">
        <div
          className="h-full transition-[width] duration-500"
          style={{
            width: `${pct}%`,
            background: soldOut || pct >= 100 ? 'var(--pd-accent-orange)' : 'var(--pd-accent-yellow)',
          }}
          data-testid="tickets-progress-fill"
        />
      </div>
      <div className="flex items-center justify-between pt-2 font-mono text-xs text-muted-sage" data-testid="tickets-progress-label">
        <span>{formatNumber(sold)} / {formatNumber(total)} tickets sold</span>
        <span>{pct}%</span>
      </div>
    </div>
  );
};

export default ProgressBar;
